// src/adminApi/WhyChooseUsApi/WhyChooseUs.js
import { getData, postData, putData, deleteData } from "../apiClient";

const ItemName = "WhyChooseUs";
const API_URL = "why_choose_us";

// get all with pagination
export const GetAll = async ({ page = 1, limit = 10, search = "" } = {}, signal = null) => {
  try {
    const queryParams = new URLSearchParams({
      page: String(page),
      limit: String(limit),
      search: search,
    });
    const result = await getData(`/${API_URL}/?${queryParams}`, {}, {}, signal);
    console.log("result", result)
    return {
      success: true,
      ...result
    };
  } catch (error) {
    console.error(`Get ${ItemName} with pagination API error:`, error);
    return { success: false, ...error };
  }
};

// get item by id
export const GetById = async (id) => {
  try {
    const result = await getData(`/${API_URL}/${id}`);
    return { data: { success: true, ...result } };
  } catch (error) {
    console.error(`Get ${ItemName} data API error:`, error);
    return { data: { success: false, error: error.message } };
  }
};

// create item
export const Create = async ({ data }) => {
  try {
    const result = await postData(`/${API_URL}/`, data, { "Content-Type": "multipart/form-data" });
    return { data: { success: true, data: result } };
  } catch (error) {
    console.error(`Create ${ItemName} API error:`, error);
    return { data: { success: false, error: error.message, status: error.status } };
  }
};

// update item
export const Update = async ({ id, data }) => {
  try {
    const result = await putData(`/${API_URL}/${id}`, data, { "Content-Type": "multipart/form-data" });
    return { data: { success: true, data: result } };
  } catch (error) {
    console.error(`Update ${ItemName} API error:`, error);
    return { data: { success: false, error: error.message, status: error.status } };
  }
};

// delete item
export const Delete = async (id) => {
  try {
    const result = await deleteData(`/${API_URL}/${id}`);
    return { data: { success: true, data: result } };
  } catch (error) {
    console.error(`Delete ${ItemName} API error:`, error);
    return { data: { success: false, error: error.message } };
  }
};

